// Critical fonts are inlined in app.blade.php to avoid Document→CSS→Font chain (LCP)
import 'bootstrap';
import '../sass/app.scss';
import '../css/style.css';
import '../css/swiper-bundle.min.css';
import '../css/apexcharts.css';
import '../css/extra.css';
import '../css/responsive.css';
import '@bhplugin/vue3-datatable/dist/style.css'
// import Vue3Datatable from '@bhplugin/vue3-datatable'

import { createApp, h, Fragment } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { Ziggy } from './ziggy.js';
import VueCookies from 'vue-cookies';
import { createStore } from 'vuex';
import CookieBanner from '@/Components/CookieBanner.vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Non-critical fonts (SuisseWorks, FontAwesome): load after critical path to avoid LCP chain
const loadDeferredAssets = () => {
    import('../fonts/fonts.css');
    import('../css/all.min.css');
    import('../css/fontawesome-display.css');
};

if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
        // Defer past typical LCP window (~2.5s) so these don't extend critical path latency
        const deferMs = 4000;
        if ('requestIdleCallback' in window) {
            requestIdleCallback(loadDeferredAssets, { timeout: deferMs });
        } else {
            setTimeout(loadDeferredAssets, deferMs);
        }
    }, { once: true });
}

const store = createStore({
    state: {
        currency: 'ron'
    },
    mutations: {
        setCurrency(state, currency) {
            state.currency = currency;
        }
    },
    actions: {
        updateCurrency({ commit }, currency) {
            commit('setCurrency', currency);
        }
    },
    getters: {
        currentCurrency: (state) => state.currency
    }
});

createInertiaApp({
    title: (title) => title ? `${title}` : appName,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(Fragment, null, [
                h(App, props),
                h(CookieBanner),
            ]),
        });
        
        // Merge Blade @routes into the static Ziggy map (don't overwrite).
        if (typeof window !== 'undefined') {
            if (window.Ziggy?.routes) {
                Object.assign(Ziggy.routes, window.Ziggy.routes);
            }
            window.Ziggy = Ziggy;
        }
        
        // Conditionally import and use VueApexCharts only on client side
        if (typeof window !== 'undefined') {
            import('vue3-apexcharts').then(({ default: VueApexCharts }) => {
                app.use(VueApexCharts);
            });
        }
        
        return app
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(VueCookies)
            .use(store)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
